import React from 'react';

export default function LiveIndicator() {
  return (
    <div className="flex bg-[#B82626] uppercase text-[18px] rounded-r-xl absolute top-1 left-0 z-20 text-white lg:h-[36px] lg:w-[100px] h-[18px] w-[56px] items-center justify-center pr-2">
      <div className="ml-1 w-[8px] h-[8px] lg:w-[16.8px] lg:h-[16.8px] bg-[#D9D9D9] rounded-full" />
      <p className="ml-1 lg:ml-[10px] text-[12px] lg:text-[18px] tracking-widest">live</p>
    </div>
  );
}
